import React, {useState, useEffect, useMemo} from 'react';

import {callback, usePrevious} from '../helpers.js';
import api from '../api/index.js';

import './LoginForm.scss';


export default (props) => {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');

	const login = async (e) => {
		//console.log("Try to login...", username, password);
		e.preventDefault();
		try {
			const result = await api.auth.login(username, password);
		} catch(e) {
			api.handleExceptions(e);
		}
		return false;
	}


	return <div className="login-form">
		<form onSubmit={login}>
		<input type="text" name="username"  autoComplete="username" value={username} onChange={(e)=>setUsername(e.target.value)} />
		<input type="password"  autoComplete="current-password" name="password" value={password} onChange={(e)=>setPassword(e.target.value)} />
		<input type="submit" className="block" value="login"/>
		</form>
	</div>;

}